import { Dropdown, MenuProps } from 'antd';
import React from 'react';

type PlacementType =
  | 'bottomLeft'
  | 'bottom'
  | 'bottomRight'
  | 'top'
  | 'topLeft'
  | 'topRight';

type IProps = {
  items: MenuProps['items'];
  placement: PlacementType;
  icon?: React.ReactElement;
  testId: string;
};

const AdvancedDropdown = ({ items, placement, icon, testId }: IProps) => {
  return (
    <Dropdown menu={{ items }} placement={placement} trigger={['click']}>
      <div
        data-testid={testId}
        style={{ cursor: 'pointer', display: 'inline-flex' }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {icon}
      </div>
    </Dropdown>
  );
};

export default AdvancedDropdown;
